import Skeleton from '@carvana/ds-skeleton';
import {
  Background,
  Heading,
  HeadingWrapper,
  HeroContainer,
  HeroFoldContainer,
  SubTitle
} from './Hero/Hero.styles';
import {
  StyledCard,
  Container,
  TabContainer,
  StyledTabBar,
  StyledTab,
  StyledButton
} from './VehicleEntry/Entry.styles';
import { PlateState, PlateTextWrapper, Wrapper } from './VehicleEntry/PlateEntry/PlateEntry.styles';
import { headerCopy, subHeaderCopy } from './Hero/Hero.content';
import styles from './HeroLoadingFallback.module.css';

/**
 * Loading fallback component for Suspense boundary.
 * Uses the exact same styled components and real text content to size containers,
 * then overlays skeletons on top for pixel-perfect dimensions with no layout shift.
 */
const HeroLoadingFallback = () => (
  <Background>
    <HeroContainer>
      <HeroFoldContainer>
        <HeadingWrapper>
          <Heading as="div" className={styles.relative}>
            <span className={styles.hidden} aria-hidden="true">
              {headerCopy}
            </span>
            <div className={styles.absoluteOverlay}>
              <Skeleton width="100%" height="100%" />
            </div>
          </Heading>
          <SubTitle className={styles.relative}>
            <span className={styles.hiddenPreWrap} aria-hidden="true">
              {subHeaderCopy}
            </span>
            <div className={`${styles.absoluteOverlay} ${styles.flexColumn}`}>
              <Skeleton width="100%" height="24px" />
              <Skeleton width="65%" height="24px" />
            </div>
          </SubTitle>
        </HeadingWrapper>
        <StyledCard>
          <Container>
            <TabContainer>
              <StyledTabBar className="vehicle-entry" as="div">
                <StyledTab className={`vehicle-entry ${styles.relative}`} as="div">
                  <span className={styles.hidden} aria-hidden="true">
                    License Plate
                  </span>
                  <div className={`${styles.absoluteOverlay} ${styles.flexCenter}`}>
                    <Skeleton width="80%" height="14px" />
                  </div>
                </StyledTab>
                <StyledTab className={`vehicle-entry ${styles.relative}`} as="div">
                  <span className={styles.hidden} aria-hidden="true">
                    VIN
                  </span>
                  <div className={`${styles.absoluteOverlay} ${styles.flexCenter}`}>
                    <Skeleton width="80%" height="14px" />
                  </div>
                </StyledTab>
              </StyledTabBar>
              <PlateState>
                <PlateTextWrapper>
                  <Skeleton width="100%" height="48px" />
                </PlateTextWrapper>
                <Wrapper>
                  <Skeleton width="100%" height="48px" />
                </Wrapper>
              </PlateState>
            </TabContainer>
            <StyledButton as="div" className={styles.buttonContainer}>
              <span className={styles.hidden} aria-hidden="true">
                Get your offer
              </span>
              <div className={`${styles.absoluteOverlay} ${styles.flexCenter}`}>
                <Skeleton width="100%" height="100%" />
              </div>
            </StyledButton>
          </Container>
        </StyledCard>
      </HeroFoldContainer>
    </HeroContainer>
  </Background>
);

export default HeroLoadingFallback;
